import gql from 'graphql-tag'
import { projectFragment/*, projectSummaryFragment*/ } from "@/graphql/project/projectFragments";
// import { userProfileFragment/*, bestCandidateFragment*/ } from '@/graphql/user/userProfileFragments'
// import { customerFragment } from '@/graphql/customer/customerFragments'
// import { customerContactFragment } from '@/graphql/customer/customerContactFragments'



export const GLOBALSEARCH = gql`
    query globalSearch(
        $search: String
        $currentDate: String
        $searchFilters: [String]
        $status: ProjectStatus
        $first: Int
        $page: Int
        $loadMore: String
        $sentenceMatch: Boolean
    ){
        globalSearch(
            searchText: $search
            currentDate: $currentDate
            filters: $searchFilters
            first: $first
            status: $status
            page: $page
            loadMore: $loadMore
            sentenceMatch: $sentenceMatch
        ){
            projects{
                paginatorInfo{
                    count
                    perPage
                    currentPage
                    hasMorePages
                    total
                }
                data{
                    id
                    name
                    description
                    start_date
                    end_date
                    relevance
                    status
                    updated_at
                    updated_by{
                        id
                        name
                    }

                    projectManager{
                        id
                        name
                    }
                    customers{
                        id
                        name
                    }
                }
            }
            userProfiles{
                paginatorInfo{
                    count
                    perPage
                    currentPage
                    hasMorePages
                    total
                }
                data{
                    id
                    name
                    email
                    relevance
                }
            }
            customers{
                paginatorInfo{
                    count
                    perPage
                    currentPage
                    hasMorePages
                    total
                }
                data{
                    id
                    name
                    relevance
                }
            }
            contacts {
                paginatorInfo{
                    count
                    perPage
                    currentPage
                    hasMorePages
                    total
                }
                data{
                    id
                    name
                    email
                    relevance
                }
            }
        }
    }
`

export const PROJECTSSEARCH = gql`
    query projectsSearch(
        $searchText: String
        $first: Int
        $page: Int
        $orderBy: String = "updated_at"
        $orderSort: SortOrder = DESC
    ) {
        projectsSearch(
            searchText: $searchText
            first: $first
            page: $page
            orderBy:{
                field: $orderBy
                order: $orderSort
            }
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
                total
            }
            data{
                ...projectFragment
            }
        }
    }
    ${projectFragment}
`